const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

export default function transformAgeRatings(ageRating?: string | null): string | undefined | null {
    let result = ageRating;
    if (BRAND === "kinodk") {
        switch (ageRating) {
            case 'A':
            case 'a':
            case 'all':
                result = 'Tilladt for alle';
                break;
            case '7':
                result = '7 år';
                break;
            case '11':
                result = '11 år';
                break;
            case '15':
                result = '15 år';
                break;
        }
    }
    return result;
}